import { COLOR_CRIMSON, COLOR_CYAN, COLOR_YELLOW } from '@/constants/constants'

// Matches `border: 2px` on .container in StickyNotesItem.module.scss.
export const NOTE_BORDER_WIDTH = 2

// The note fills are too pale to read as dots on the plate, so the swatches use
// the deeper token of each hue instead (Figma 79368:380965). Keyed by note fill.
export const STICKY_NOTE_DOT_COLORS: Record<string, string> = {
  [COLOR_YELLOW]: 'var(--color-code-yellow-20)',
  [COLOR_CYAN]: 'var(--color-code-topaz-22)',
  [COLOR_CRIMSON]: 'var(--color-code-purple-20)',
}

export const dotColor = (fill: string) => STICKY_NOTE_DOT_COLORS[fill] ?? fill
